import { RowDataContactUs } from "../../components/ContactUsPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the ContactUsTable factory
 */
class ContactUsRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/contact-us/read-range"
        this.accessData = "messages"
    }

    create(message: any): RowDataContactUs {
        const rowDataContactUs: RowDataContactUs = {
            id: message.id,
            fullname: message.fullname,
            email: message.email,
            phone_number: message.phone_number,
            message: message.message,

            createdAt: message.createdAt,
            updatedAt: message.updatedAt,
            action: "",
        };
        return rowDataContactUs;
    }
}

let contactUsRow: ContactUsRow | null = null;

export default function getContactUsRow(): ContactUsRow {
    if (contactUsRow === null)
        contactUsRow = new ContactUsRow()
    return contactUsRow
}